import { Paper } from '@mui/material'
import { PropsWithChildren } from 'react'

interface FormDisplayContainerProps {
  viewType: 'paper' | 'none'
  style?: React.CSSProperties
  styleJSON?: string
}

export const FormDisplayContainer = ({
  viewType = 'none',
  children,
  style = {},
  styleJSON
}: PropsWithChildren<FormDisplayContainerProps>): JSX.Element => {
  let baseStyle: React.CSSProperties = {
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 80,
    paddingRight: 80,
    userSelect: 'text',
    ...style
  }

  try {
    if (styleJSON) {
      const parsed = JSON.parse(styleJSON)
      if (typeof parsed === 'object') {
        baseStyle = Object.assign(baseStyle, JSON.parse(styleJSON))
      }
    }
  } catch (e) {}

  if (viewType === 'paper') {
    return (
      <Paper style={baseStyle}>
        {children}
      </Paper>
    )
  } else {
    return <div style={baseStyle}>{children}</div>
  }
}
